export function getErrorMessage(err: unknown, fallback?: string): string {
  if (err instanceof Error) return err.message;
  if (fallback) return fallback;
  return String(err);
}

export function truncateForUI(message: string, maxLength = 200): string {
  return message.length > maxLength
    ? `${message.slice(0, maxLength)}\u2026`
    : message;
}
